<template>
  <div class="page-home container">
    <el-button
      type="success"
      icon="el-icon-plus"
      class="mb-3 mt-5"
      @click="addVisible = true"
    >
      افزودن
    </el-button>
    <el-button
      type="info"
      icon="el-icon-plus"
      class="mb-3 mt-5"
      @click="importDevicesVisible = true"
    >
      افزودن گروهی
    </el-button>
    <el-button
      type="info"
      class="mb-3 mt-5"
      icon="el-icon-edit-outline"
      :disabled="totalItemsCount === 0"
      @click="groupSetting = true"
    >
      <span>تنظیمات گروهی </span>
      <span>({{ selection.length ? selection.length : totalItemsCount }})</span>
    </el-button>
    <data-table
      ref="table"
      class="mt-3"
      title="لیست دستگاه ها"
      uid="table-devices"
      :before-update="beforeUpdate"
      :selection.sync="selectionComputed"
      :map-rows="mapRows"
      :query="query"
      :options="options"
      :on-edit="
        (item) => {
          editing = item.id
          editVisible = true
        }
      "
      @totalRows="(totalRows) => (totalItemsCount = totalRows)"
    >
      <el-table-column
        prop="user.name"
        label="کاربر"
        align="center"
        min-width="120"
        sortable="custom"
      >
        <user-action-button
          slot-scope="{ row }"
          :user="row.user"
          class="font-9"
          :device-id="row.id"
          :show-info="true"
          :show-reset-device="true"
          @update="onBatchUpdate"
        />
      </el-table-column>
      <el-table-column
        prop="imei"
        label="کد رهگیری"
        align="center"
        min-width="130"
      >
        <p slot-scope="{ row }" class="font-10">
          {{ row.imei }}
        </p></el-table-column
      >
      <el-table-column
        prop="title"
        label="عنوان"
        align="center"
        min-width="80"
        show-overflow-tooltip
        sortable="custom"
      >
        <p
          slot-scope="{ row }"
          class="font-10"
          :class="{ 'text-grey': !row.title }"
        >
          {{ row.title || '.....' }}
        </p>
      </el-table-column>
      <el-table-column
        prop="humidity"
        label="رطوبت"
        align="center"
        min-width="90"
        sortable="custom"
      >
        <p
          v-if="row.humidity && row.humidity.value"
          slot-scope="{ row }"
          style="direction: ltr"
          class="font-10"
          :class="{ 'text-danger': row.humidity.alarm }"
        >
          {{ row.humidity.value + '  %' }}
          <i v-if="row.humidity.alarm" class="el-icon-warning text-danger"></i>
        </p>
        <p v-else class="text-grey">.....</p>
      </el-table-column>
      <el-table-column
        prop="temperature"
        label="دما"
        align="center"
        min-width="90"
        sortable="custom"
      >
        <p
          v-if="row.temperature && row.temperature.value"
          slot-scope="{ row }"
          style="direction: ltr"
          class="font-10"
          :class="{ 'text-danger': row.temperature.alarm }"
        >
          {{ row.temperature.value + '  ˚C' }}
          <i
            v-if="row.temperature.alarm"
            class="el-icon-warning text-danger"
          ></i>
        </p>
        <p v-else class="text-grey">.....</p>
      </el-table-column>
      <el-table-column
        prop="batteryVoltage"
        label="باتری"
        align="center"
        min-width="75"
        sortable="custom"
      >
        <p
          v-if="row.battery && row.battery.value"
          slot-scope="{ row }"
          style="direction: ltr"
          class="font-10"
          :class="{ 'text-danger': row.battery.alarm }"
        >
          {{ row.battery.value + '  %' }}
          <i v-if="row.battery.alarm" class="el-icon-warning text-danger"></i>
        </p>
        <p v-else class="text-grey">.....</p>
      </el-table-column>
      <el-table-column
        prop="address"
        label="موقعیت"
        align="center"
        min-width="90"
        class="font-10"
      >
        <p v-if="row.address" slot-scope="{ row }" style="direction: ltr">
          {{ row.address }}
        </p>
        <p v-else class="text-grey">.....</p>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="تاریخ ایجاد"
        align="center"
        min-width="105"
        sortable="custom"
      >
        <date-time-display
          slot-scope="{ row }"
          :date="row.createdAt"
          class="rounded-md font-10"
          :type="'danger'"
        />
      </el-table-column>
      <el-table-column
        prop="lastReport"
        label="آخرین سیگنال"
        align="center"
        min-width="120"
        sortable="custom"
      >
        <date-time-display
          v-if="row.lastReport"
          slot-scope="{ row }"
          :date="row.lastReport.createdAt"
          class="rounded-md font-10"
          :type="'danger'"
        />
      </el-table-column>
    </data-table>
    <device-form
      :show.sync="editVisible"
      :editing-id.sync="editing"
      @updateTable="update"
    />
    <group-setting
      :numbers="selection.map((u) => u.mobile)"
      :filters="settingFilters"
      :selection.sync="selection"
      :show.sync="groupSetting"
    />
    <import-devices-form
      :show.sync="importDevicesVisible"
      @updateTable="update"
    />
    <add-device-form :show.sync="addVisible" @updateTable="update" />
  </div>
</template>

<script>
import DevicesQuery from '@/graphql/device/Devices.gql'
import DeviceForm from '@/views/Device/Form'
import AddDeviceForm from '@/views/Device/Add'
import ImportDevicesForm from '@/views/Device/ImportDevicesForm'
import DateTimeDisplay from '@/components/DateTimeDisplay'
import UserSelectSimple from '@/components/UserSelectSimple'
import UserActionButton from '@/components/UserActionButton'
import GroupSetting from '@/views/Device/GroupSetting'
export default {
  name: 'DevicesList',
  components: {
    DateTimeDisplay,
    DeviceForm,
    AddDeviceForm,
    GroupSetting,
    ImportDevicesForm,
    UserActionButton,
  },
  data() {
    return {
      loading: false,
      query: DevicesQuery,
      editVisible: false,
      addVisible: false,
      groupSetting: false,
      totalItemsCount: undefined,
      selection: [],
      messageFilters: [],
      settingFilters: [],
      importDevicesVisible: false,
      editing: null,
    }
  },
  computed: {
    selectionComputed: {
      set(val) {
        if (Array.isArray(val)) this.selection = val
      },
      get() {
        return this.selection
      },
    },
    options() {
      let filters = [
        {
          id: 'user',
          field: 'userId',
          component: UserSelectSimple,
          value: this.$route.params.userId,
          attr: {
            type: 'text',
            placeholder: 'جستجو در نام کاربر',
          },
        },
        {
          type: 'input',
          field: 'imei',
          attr: {
            type: 'text',
            placeholder: 'جستجو در IMEI',
          },
        },
        {
          type: 'input',
          field: 'title',
          attr: {
            type: 'text',
            placeholder: 'جستجو در عنوان',
          },
        },
        {
          id: 'dateFrom',
          type: 'date',
          field: 'createdAt',
          op: '>=',
          attr: {
            placeholder: 'شروع تاریخ ایجاد',
          },
        },
        {
          id: 'dateTo',
          type: 'date',
          field: 'createdAt',
          op: '<=',
          attr: {
            format: 'YYYY/MM/DD 23:59:59',
            displayFormat: 'jYYYY/jMM/jDD',
            placeholder: 'پایان تاریخ ایجاد',
          },
        },
        {
          id: 'userCondition',
          type: 'select',
          field: 'userId',
          attr: { placeholder: 'وضعیت' },
          op: '&',
          options: [
            { id: 1, title: 'تخصیص یافته', value: 'any' },
            { id: 0, title: 'آزاد ', value: null },
          ],
        },
      ]
      return {
        filters,
        columns: [],
      }
    },
  },
  methods: {
    resetDevice(deviceId) {
      this.$confirm('آیا از ریست کردن دستگاه اطمینان دارید؟').then(() => {
        this.apollo
          .mutate({
            query: ResetQuery,
            variables: { id: deviceId },
          })
          .then(() => {
            this.$message.success('دستگاه مورد نظر با موفقیت ریست شد')
            this.onBatchUpdate()
          })
      })
    },
    mapRows(item) {
      let output = { ...item }
      let alarms = this.getReportAlarms(output.lastReport, output.setting)
      output.humidity = {
        alarm: alarms.includes('humidity'),
        value:
          output.lastReport && output.lastReport.humidity
            ? output.lastReport.humidity
            : null,
      }
      output.temperature = {
        alarm: alarms.includes('temperature'),
        value:
          output.lastReport && output.lastReport.temperature
            ? output.lastReport.temperature
            : null,
      }

      output.battery = {
        alarm: alarms.includes('battery'),
        value:
          output.lastReport && output.lastReport.batteryVoltage
            ? this.voltagePercent(output.lastReport.batteryVoltage)
            : null,
      }

      output.address =
        output.lastReport &&
        output.lastReport.address &&
        output.lastReport.address.county
          ? output.lastReport.address.county
          : null

      return output
    },
    getReportAlarms(lastReport, setting) {
      let alarm = setting.alarm

      let alarmSetting = {
        title: alarm.title,
        temperature: {
          min: alarm.minTemperature,
          max: alarm.maxTemperature,
          active: alarm.deviceTemperature,
        },
        humidity: {
          min: alarm.minHumidity,
          max: alarm.maxHumidity,
          active: alarm.deviceHumidity,
        },
        battery: {
          value: alarm.batteryAlarmLevel,
          active: alarm.deviceBattery,
        },
        samplingTime: {
          value: alarm.samplingTime,
        },
      }

      let alarms = []
      // Check Temperature
      if (
        alarmSetting.temperature.active &&
        ((lastReport &&
          lastReport.temperature > alarmSetting.temperature.max) ||
          (lastReport && lastReport.temperature < alarmSetting.temperature.min))
      )
        alarms.push('temperature')

      // Check Humidity
      if (
        alarmSetting.humidity.active &&
        ((lastReport && lastReport.humidity > alarmSetting.humidity.max) ||
          (lastReport && lastReport.humidity < alarmSetting.humidity.min))
      )
        alarms.push('humidity')

      // Check Battery
      if (
        alarmSetting.battery.active &&
        lastReport &&
        lastReport.battery < alarmSetting.battery.value
      )
        alarms.push('battery')
      return alarms
    },
    onBatchUpdate() {
      const table = this.$refs.table
      table.$refs.table.clearSelection()
      table.update()
    },
    update() {
      this.$refs.table.update()
    },
    beforeUpdate(variables, done) {
      //--check user condition filter--
      if (variables.filter && variables.filter.filters) {
        variables.filter.filters.forEach((filter) => {
          if (filter.op === '&') {
            filter.op = filter.value === 0 ? '=' : '!='
            filter.value = null
          }
        })
      }
      this.settingFilters = variables.filter.filters
      done(variables)
    },
    voltagePercent(voltage) {
      let range =
        this.$enums.batteryRange['max'] - this.$enums.batteryRange['min']
      if (voltage > this.$enums.batteryRange['max'])
        voltage = this.$enums.batteryRange['max']
      if (voltage < this.$enums.batteryRange['min'])
        voltage = this.$enums.batteryRange['min']
      let diff = voltage - this.$enums.batteryRange['min']
      return Math.floor((diff / range) * 100)
    },
    showEdit(id) {
      this.editing = id
      this.editVisible = true
    },
  },
}
</script>
